import { AddCircle, Delete, Edit } from '@mui/icons-material';
import {
  Button,
  Divider,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  Menu,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { Box } from '@mui/system';
import React, { forwardRef, useEffect } from 'react';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useConfirm } from 'material-ui-confirm';
import CloseIcon from '@mui/icons-material/Close';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import {
  useMainFrameDispatch,
  useMainFrameState,
} from '../../component/MainUIFrame/MainFrame';
import {
  ACTION_OPEN_RIGHT_FLOATING_DRAWER,
  ACTION_RIGHT_DRAWER,
  ACTION_RIGHT_DRAWER_JSX,
  ACTION_RIGHT_DRAWER_NOT,
} from '../../component/MainUIFrame/constants';
import {
  setProcedure,
  setProcedureDiagnosis,
} from '../../redux/features/claimSlice';
import { REDUX_OPERATIONS } from '../../redux/reduxConstants';
import { DIAGNOSIS_SEQUENCE } from '../../component/claims_lists';
import { setToolbarButtons } from '../../redux/features/toolbarSlice';
import { toolbarConstants } from '../../constants/toolbar/toolbarConstants';
import PatientSearchPage from '../../component/FhirComponents/template/Claims/patientSearchPage';
import AddChargeItems from './addChargeItems';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import moment from 'moment';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import AxiosInstance, {
  ehrAPIBaseService,
  ehrAPIService,
} from '../../http-common';
import { setProgress } from '../../redux/features/progressSlice';
import { setSnackbarState } from '../../redux/features/snackbarSlice';
import axios from 'axios';
import _, { isUndefined, update } from 'lodash';
import dayjs from 'dayjs';
import { generateNotifications } from '../../component/reusableLogic';
import { useSnackbar } from 'notistack';
import { DateSelectorWithTopLabelComponent } from '../../component/FhirComponents/uiComponent/fhirComponentUi';
import { useRef } from 'react';
import jwtDecode from 'jwt-decode';
import {
  clearChargeItem,
  setChargeItem,
} from '../../redux/features/invoiceSlice';
import { setEditMode } from '../../redux/features/editModeSlice';
import { useNavigate } from 'react-router-dom';
import { red } from '@mui/material/colors';
import { prettifyPhone, prettifyPhoneIndianFormat } from '../../config/common';

const invoiceStatus = [
  {
    display: 'Draft',
  },
  {
    display: 'Issued',
  },
  {
    display: 'Balanced',
  },
  {
    display: 'Cancelled',
  },
  {
    display: 'Entered-In-Error',
  },
];

const initialFMHStateFromProps = invoiceObject => {
  console.log('', invoiceObject);
  if (!_.isUndefined(invoiceObject) || !_.isEmpty(invoiceObject)) {
    return {
      id: '',
    };
  } else {
    return {
      id: '',
    };
  }
};

const InvoiceNewPage = forwardRef((props, ref) => {
  console.log('is edit ', props?.isEdit);
  console.log('invoice object , ', props?.invoiceObject);
  const navigate = useNavigate();
  const invoiceDateRef = useRef();
  const confirmation = useConfirm();
  const reduxDispatch = useDispatch();
  const dispatch = useMainFrameDispatch();
  const chargeItemState = useSelector(state => state.invoice);
  const { isRightDrawer, isDark } = useMainFrameState();
  let total = 0;
  const [invoiceDialog, setInvoiceDialog] = useState({
    open: false,
    isEditMode: false,
    data: {},
  });
  const editMode = useSelector(state => state?.edit?.editMode);
  const selectedVersion = useSelector(
    state => state.changeVersion.selectedVersion
  );
  const [errorMessage, setErrorMessage] = useState('');
  const [menuOpen, setMenuOpen] = useState([]);
  const [selectedPatient, setSelectedPatient] = useState({});
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [patientName, setPatientName] = useState();
  const [patientData, setPatientData] = useState({});
  const [organizationName, setOrganizationName] = useState();
  const [organizationType, setOrganizationType] = useState();
  const [organizationData, setOrganizationData] = useState([]);
  const [selectedPatientNew, setSelectedPatientNew] = useState([]);

  const [invoiceInitialState, setInvoiceinitialState] = useState({
    status: '',
    date: dayjs().format('YYYY-MM-DD'),
    subject: '',
    totalPriceComponent: 0,
  });
  const [chargeItems, setChargeItems] = useState([]);

  useEffect(() => {
    console.log('selectedPatientNew', selectedPatientNew);
  }, [selectedPatientNew]);

  useEffect(() => {
    console.log('organization data', organizationData);
  }, [organizationData]);

  const dateValidationObject = {
    label: 'Invoice Date',
    name: 'date',
    value: invoiceInitialState?.date,
    validation: {
      required: true,
    },
    ref: invoiceDateRef,
  };

  const dateValidationUpdate = {
    label: 'Invoice Date',
    name: 'date',
    value: props?.invoiceObject?.date,
  };

  const handleOnChange = event => {
    const { name, value } = event?.target;
    setInvoiceinitialState({
      ...invoiceInitialState,
      [name]: value,
    });
  };

  const getInvoiceList = async () => {
    try {
      let invoiceId = props?.invoiceObject?.id;
      let updatedDate;
      let updatedStatus;
      let updatedGrandTotal;
      if (invoiceId !== undefined) {
        const response = await ehrAPIBaseService.get(
          `fhir/search/?resourceType=Invoice&_id=` + invoiceId
        );
        console.log(
          'response of invoice ',
          response?.data?.entry?.[0]?.resource?.lineItem?.length
        );
        updatedDate = response?.data?.entry?.[0]?.resource?.date;
        updatedStatus = response?.data?.entry?.[0]?.resource.status;
        updatedGrandTotal =
          response?.data?.entry?.[0]?.resource.totalPriceComponent[0].amount
            .value;

        let tempRows1 = [];
        let tempRows2 = [];
        for (
          let i = 0;
          i < response?.data?.entry?.[0]?.resource?.lineItem?.length;
          i++
        ) {
          console.log(
            'reference ',
            response?.data?.entry?.[0]?.resource?.lineItem?.[i]
              ?.chargeItemReference?.reference
          );
          let ref =
            response?.data?.entry?.[0]?.resource?.lineItem?.[i]
              ?.chargeItemReference?.reference;
          let chargeIds = ref.split('/');
          tempRows1.push(chargeIds[1]);
        }
        console.log('tempRows --- ', tempRows1);
        const commaSep = tempRows1.map(item => item).join(',');
        console.log('comma sep values ', commaSep);
        console.log(
          'url ',
          process.env.REACT_APP_API_URL +
            `/fhir/search/?resourceType=ChargeItem&_id=${commaSep}`
        );

        const chargeItemResponse = await ehrAPIBaseService.get(
          `fhir/search/?resourceType=ChargeItem&_id=${commaSep}`
        );
        console.log('response of chargeItem ', chargeItemResponse);
        let tempRows = [];
        for (const item of chargeItemResponse?.data?.entry) {
          let singleRow = {};
          singleRow.id = _.get(item, 'resource.id', '');
          singleRow.price = _.get(item, 'resource.priceOverride.value', '');
          singleRow.quantity = _.get(item, 'resource.quantity.value', '');
          singleRow.status = _.get(item, 'resource.status', '');
          singleRow.note = _.get(item, 'resource.note[0].text');
          tempRows.push(singleRow);
        }
        console.log('temp rows :', tempRows);
        tempRows.reverse();
        setChargeItems(tempRows);
        reduxDispatch(clearChargeItem());
        props?.setInvoiceObject({
          ...props.invoiceObject,
          date: dayjs(updatedDate).format('YYYY-MM-DD'),
          status: updatedStatus,
          totalPriceComponent: updatedGrandTotal,
        });
      }
    } catch (e) {
      console.error(`EHR->ehrGetAllInvoices ${e}`);
    }
  };

  useEffect(() => {
    if (editMode) {
      setInvoiceinitialState({
        ...invoiceInitialState,
        status: props?.invoiceObject?.status,
        date: props?.invoiceObject?.date,
      });
    } else {
      reduxDispatch(clearChargeItem());
    }
  }, [editMode]);

  useEffect(() => {
    if (editMode === true) {
      chargeItems.forEach(chargeItems => {
        reduxDispatch(
          setChargeItem({
            operation: REDUX_OPERATIONS.ADD,
            sequence: null,
            chargeItems,
          })
        );
      });
    }
  }, [chargeItems, editMode]);

  useEffect(() => {
    reduxDispatch(setEditMode(false));
  }, [props?.listView]);

  useEffect(() => {
    getInvoiceList();
  }, []);

  let selectedPatientId = 0;
  if (props?.invoiceObject?.patientId) {
    selectedPatientId = props?.invoiceObject?.patientId;
    console.log('selected patient id ', selectedPatientId);
  } else {
    selectedPatientId = selectedPatient?.id;
  }

  const getPatientAndPractitionerData = async () => {
    let patId = '';
    if (props?.invoiceObject?.patientId) {
      patId = props?.invoiceObject?.patientId;
    }
    try {
      const patientResponse = await ehrAPIBaseService.get(
        `fhir/getResource?resourceId=${patId}&resourceType=Patient`
      );

      const jwtPayload = jwtDecode(localStorage.getItem('jwtToken'));
      const tenantId = jwtPayload?.firebase?.tenant;
      const response = await ehrAPIBaseService.get(
        `fhir/search/Organization?identifier=${tenantId}`
      );
      console.log('testing...', response);
      const { address, telecom } = patientResponse.data;
      setSelectedPatientNew([patientResponse.data]);
      setPatientName(props?.invoiceObject?.patient);
      if (address && address.length > 0) {
        const patientAddress = {
          city: address[0].city,
          state: address[0].state,
          country: address[0].country,
          addressLine1: address[0].line[0],
          addressLine2: address[0].line[1],
          postalCode: address[0].postalCode,
        };
        setPatientData(patientAddress);
      }
      if (telecom && telecom.length > 0) {
        const phoneNumber = telecom.find(item => item.system === 'phone');
        if (phoneNumber) {
          setPatientData(prevData => ({
            ...prevData,
            phoneNumber: phoneNumber.value,
          }));
        }
      }

      if (response.data && response.data.total > 0) {
        const organization = response.data.entry[0].resource;
        setOrganizationName(organization.name);
        setOrganizationType(organization.type[0].coding[0].display);
      }
      let tempRows = [];
      if (response?.data?.total !== 0) {
        for (const item of response?.data?.entry) {
          let singleRow = {};

          singleRow.city = _.get(item, 'resource.contact[0].address.city', '');
          singleRow.address = _.get(
            item,
            'resource.contact[0].address.line[0]',
            ''
          );
          singleRow.state = _.get(
            item,
            'resource.contact[0].address.state',
            ''
          );
          singleRow.postalCode = _.get(
            item,
            'resource.contact[0].address.postalCode',
            ''
          );
          singleRow.phone = _.get(
            item,
            'resource.contact[0].telecom[0].value',
            ''
          );
          singleRow.fax = _.get(
            item,
            'resource.contact[0].telecom[3].value',
            ''
          );

          tempRows.push(singleRow);
        }
        console.log('temp rows :', tempRows);
        setOrganizationData(tempRows);
      }

      console.log('patient details', patientResponse);
      console.log('organization details', response);
    } catch (e) {
      console.log('failed to get patient/organization info...');
    }
  };

  useEffect(() => {
    getPatientAndPractitionerData();
  }, []);

  useEffect(() => {
    !props?.listView &&
      reduxDispatch(
        setToolbarButtons({
          actions: [
            {
              key: toolbarConstants.CANCEL,
              clickAction: () => {
                // props?.setListView(true);
                // props?.setDisabled(true);
                // props?.setSelectionModel('');
                navigate(`/invoice`);
              },
            },
            {
              key: toolbarConstants.SAVE,
              clickAction: () => {
                if (_.isEmpty(props?.invoiceObject)) {
                  if (
                    invoiceInitialState?.status === '' ||
                    invoiceInitialState?.date === ''
                  ) {
                    setErrorMessage('This field cannot be empty');
                  } else {
                    handleSubmit('save');
                  }
                } else {
                  handleSubmit('update');
                }
              },
              disabled: props?.isEdit && !editMode,
            },
            {
              key: toolbarConstants.PRINT,
              clickAction: () => {
                props?.setPrint(true);
              },
              disabled: editMode ? props?.isEdit : !props?.isEdit,
            },
          ],
          module: 'Invoice',
          editSwitch: props?.isEdit,
          currentState: chargeItemState,
          invoiceInitialState,
        })
      );
    return () =>
      !props?.listView && reduxDispatch(setToolbarButtons({ actions: [] }));
  }, [
    chargeItemState,
    invoiceInitialState,
    props?.listView,
    props?.isEdit,
    editMode,
  ]);

  const handleSubmit = async action => {
    console.log('new patinet info ', selectedPatientNew);
    console.log('selected patinet length ', selectedPatientNew.length);
    if (action === 'save' && selectedPatientNew.length === 0) {
      generateNotifications({
        title: 'Please select Patient',
        descriptions: 'Please select Patient',
        enqueueSnackbar,
        closeSnackbar,
        reduxDispatch,
      });
      return;
    }
    if (action === 'save' && chargeItemState?.chargeItem?.length === 0) {
      generateNotifications({
        title: 'Please add any charge item',
        descriptions: 'Please add any charge item',
        enqueueSnackbar,
        closeSnackbar,
        reduxDispatch,
      });
      return;
    }
    if (isUndefined(selectedPatientNew[0]?.id)) {
      generateNotifications({
        title: 'Please select a patient',
        descriptions: 'Please select a patient',
        enqueueSnackbar,
        closeSnackbar,
        reduxDispatch,
      });
      return;
    }
    const dateData = invoiceDateRef?.current?.onValidate();
    console.log(chargeItemState);
    console.log('cahrgeitemeditmode', chargeItemState?.chargeItem);
    let chargeItemIds = [];
    let total = 0;
    if (!dateData?.valid) {
      return;
    }
    if (action === 'save') {
      for (let i = 0; i < chargeItemState?.chargeItem?.length; i++) {
        const chargeItem = {
          code: {
            coding: [
              {
                code: '01510',
                display:
                  'Additional flat rate for observation after diagnostic coronary angiography',
              },
            ],
          },
          note: [
            {
              text: chargeItemState?.chargeItem[i].note,
            },
          ],
          priceOverride: {
            // currency: 'USD',
            currency: selectedVersion == 'IN' ? 'INR' : 'USD',
            value: parseFloat(chargeItemState?.chargeItem[i].price),
          },
          quantity: {
            value: parseFloat(chargeItemState?.chargeItem[i].quantity),
          },
          resourceType: 'ChargeItem',
          status: chargeItemState?.chargeItem[i].status,
          subject: {
            reference: 'Patient/' + selectedPatientNew[0]?.id,
          },
        };
        console.log('charge item req ', chargeItem);
        if (isNaN(parseFloat(chargeItemState?.chargeItem?.[i]?.price))) {
          total = total;
        } else {
          total = total + parseFloat(chargeItemState?.chargeItem?.[i]?.price);
        }
        console.log('Total : ', total);
        try {
          const response = await ehrAPIService.post(
            `createResource`,
            chargeItem
          );
          console.log('charge item response ', response);
          chargeItemIds.push(response?.data?.id);
        } catch (e) {
          console.log('exception ', e);
        }
      }
    }
    if (action === 'update') {
      for (let i = 0; i < chargeItemState?.chargeItem?.length; i++) {
        const chargeItem = {
          code: {
            coding: [
              {
                code: '01510',
                display:
                  'Additional flat rate for observation after diagnostic coronary angiography',
              },
            ],
          },
          note: [
            {
              text: chargeItemState?.chargeItem[i].note,
            },
          ],
          priceOverride: {
            // currency: 'USD',
            currency: selectedVersion == 'IN' ? 'INR' : 'USD',
            value: parseFloat(chargeItemState?.chargeItem[i].price),
          },
          quantity: {
            value: parseFloat(chargeItemState?.chargeItem[i].quantity),
          },
          resourceType: 'ChargeItem',
          status: chargeItemState?.chargeItem[i].status,
          subject: {
            reference: 'Patient/' + selectedPatientNew[0]?.id,
          },
        };
        console.log('charge item req ', chargeItem);
        if (isNaN(parseFloat(chargeItemState?.chargeItem?.[i]?.price))) {
          total = total;
        } else {
          total = total + parseFloat(chargeItemState?.chargeItem?.[i]?.price);
        }
        console.log('Total : ', total);
        try {
          const response = await ehrAPIService.post(
            `createResource`,
            chargeItem
          );
          console.log('charge item response ', response);
          chargeItemIds.push(response?.data?.id);
        } catch (e) {
          console.log('exception ', e);
        }
      }
    }
    console.log('created charge items are ', chargeItemIds);

    const invoiceRequest = {
      resourceType: 'Invoice',
      status: invoiceInitialState?.status,
      date: dayjs(invoiceInitialState?.date).format('YYYY-MM-DD'),
      subject: {
        reference: 'Patient/' + selectedPatientNew[0]?.id,
        display:
          selectedPatientNew[0]?.name[0]?.given[0] +
          ' ' +
          selectedPatientNew[0]?.name[0]?.given[2],
      },
      lineItem: [
        {
          chargeItemReference: {
            reference: 'ChargeItem/eaa696c7-b95b-4bc3-a175-e8db0e981207',
            type: 'ChargeItem',
          },
        },
      ],
      totalNet: {
        // currency: 'DOLLAR',
        currency: 'INDIAN RUPEES',
        value: total,
      },
      totalPriceComponent: [
        {
          type: 'base',
          amount: {
            // currency: 'DOLLAR',
            currency: 'INDIAN RUPEES',
            value: total,
          },
        },
      ],
    };
    var lineItemColle = [];
    for (let i = 0; i < chargeItemIds.length; i++) {
      var singleRow = {};
      singleRow.chargeItemReference = {
        reference: 'ChargeItem/' + chargeItemIds[i],
        type: 'ChargeItem',
      };
      lineItemColle.push(singleRow);
    }
    invoiceRequest.lineItem = lineItemColle;
    console.log('Invoice request body', invoiceRequest);
    let type = '';
    let message = '';
    let description = '';
    try {
      let resource;
      let response;
      if (action === 'save') {
        resource = `createResource`;
        response = await ehrAPIService.post(resource, invoiceRequest);
      } else {
        resource = `updateResource?resourceType=Invoice`;
        invoiceRequest.id = props?.invoiceObject?.id;
        response = await ehrAPIService.put(resource, invoiceRequest);
      }
      // const response = await ehrAPIService.method(
      //   resource,
      //   invoiceRequest
      // );
      console.log('invoice response ', response);
      type = 'success';
      message =
        action === 'save'
          ? 'Invoice Created Successfully'
          : 'Invoice Updated Successfully';
      description =
        action === 'save'
          ? 'Invoice Created Successfully'
          : 'Invoice Updated Successfully';
      // props?.setListView(true);
      action === 'save' && navigate(`/invoice`);
      action === 'update' && getInvoiceList();
      reduxDispatch(setEditMode(false));
    } catch (e) {
      console.log('exception ', e);
      type = 'error';
      message = `Invoice${action === 'save' ? 'creation' : 'updation'} failed`;
      description = `Something went wrong while ${
        action === 'save' ? 'creating' : 'updating'
      } Invoice,Please try again.`;
    } finally {
      reduxDispatch(setProgress(false));
      generateNotifications({
        title: message,
        descriptions: description,
        enqueueSnackbar,
        closeSnackbar,
        reduxDispatch,
      });
    }
  };

  useEffect(() => {
    return () => {
      dispatch({ type: ACTION_RIGHT_DRAWER_NOT });
    };
  }, []);

  useEffect(() => {
    if (invoiceDialog.open) {
      dispatch({ type: ACTION_RIGHT_DRAWER });
      dispatch({ type: ACTION_OPEN_RIGHT_FLOATING_DRAWER });
      dispatch({
        type: ACTION_RIGHT_DRAWER_JSX,
        payload: invoiceDialog.open ? (
          <AddChargeItems dialog={invoiceDialog} setDialog={setInvoiceDialog} />
        ) : null,
      });
    } else {
      dispatch({ type: ACTION_RIGHT_DRAWER_NOT });
    }
  }, [invoiceDialog]);

  const closeMenu = () => {
    setMenuOpen([]);
  };
  const openMenuChargeItem = (id, event) => {
    let tempMenuOpen = [...menuOpen];
    tempMenuOpen[id] = event.currentTarget;
    setMenuOpen([...tempMenuOpen]);
  };

  const editChargeItem = idx => {
    console.log('chargeItem ', chargeItemState?.chargeItem[idx]);
    dispatch({ type: ACTION_RIGHT_DRAWER_NOT });
    setInvoiceDialog({
      open: true,
      isEditMode: true,
      data:
        chargeItemState?.chargeItem[idx] || chargeItemState?.chargeItem[idx],
    });
    closeMenu();
  };

  const backButtonHandle = () => {
    // props?.setListView(true);
    // props?.setDisabled(true);
    // props?.setSelectionModel('');
  };

  return (
    <>
      {props?.isEdit ? (
        <Grid
          item
          xs={12}
          className="overflow-grid"
          style={{ padding: '0px 15px' }}
          ref={ref}
        >
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography
                style={{
                  color: '#387CA3',
                  paddingBottom: '5px',
                  fontWeight: 'bold',
                  fontSize: '20px',
                }}
              >
                Patient Invoice
              </Typography>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Divider
              style={{
                border: '1px solid #387CA3',
              }}
            />
          </Grid>
          <Grid container spacing={2} style={{ paddingTop: '15px' }}>
            <Grid item xs={10}>
              {console.log('organization -----', organizationData)}
              <Box
                sx={{
                  display: 'flex',
                  // justifyContent: 'space-around',
                  // justifyContent: 'space-evenly',
                  justifyContent: 'space-between',
                }}
              >
                <Box sx={{ my: 1 }}>
                  <Box
                    sx={{
                      marginBottom: 1,
                    }}
                  >
                    <Typography
                      style={{
                        color: '#387CA3',

                        fontWeight: 500,
                      }}
                    >
                      Billing From:
                    </Typography>
                  </Box>
                  <Box sx={{ display: 'flex' }}>
                    <Typography>{organizationName}</Typography>
                  </Box>
                  <Box sx={{ display: 'flex' }}>
                    <Typography>{organizationType}</Typography>
                  </Box>
                  <Box sx={{ display: 'flex' }}>
                    <Typography>{organizationData?.[0]?.address}</Typography>
                  </Box>

                  <Box sx={{ display: 'flex' }}>
                    <Typography>
                      Phone Number:{' '}
                      {selectedVersion === 'IN'
                        ? prettifyPhoneIndianFormat(
                            organizationData?.[0]?.phone
                          )
                        : prettifyPhone(organizationData?.[0]?.phone)}
                    </Typography>
                  </Box>
                  <Box sx={{ display: 'flex' }}>
                    <Typography>
                      Fax Number: {organizationData?.[0]?.fax}
                    </Typography>
                  </Box>
                </Box>
                <Divider />
                <Box sx={{ my: 1 }}>
                  <Box
                    sx={{
                      marginBottom: 1,
                    }}
                  >
                    <Typography style={{ color: '#387CA3', fontWeight: 500 }}>
                      Billing To:
                    </Typography>
                  </Box>
                  <Box sx={{ display: 'flex' }}>
                    <Typography>{patientName}</Typography>
                  </Box>
                  {/* <Box sx={{ display: 'flex' }}>
                    <Typography>{patientData?.addressLine1} </Typography>
                    <Typography>{patientData?.addressLine2}</Typography>
                  </Box> */}
                  <Box sx={{ display: 'flex' }}>
                    <Typography>
                      {patientData?.city} {''}
                    </Typography>
                    <Typography sx={{ mx: 1 }}>
                      {patientData?.state} {''}
                    </Typography>
                    <Typography>{patientData?.postalCode}</Typography>
                  </Box>
                  <Box sx={{ display: 'flex' }}>
                    <Typography>
                      Phone Number:{' '}
                      {selectedVersion === 'IN'
                        ? prettifyPhoneIndianFormat(patientData?.phoneNumber)
                        : prettifyPhone(patientData?.phoneNumber)}
                    </Typography>
                  </Box>
                </Box>
                <Divider />
                {editMode ? null : (
                  <Box sx={{ my: 1 }}>
                    <Box
                      sx={{
                        marginBottom: 1,
                      }}
                    >
                      <Typography style={{ color: '#387CA3', fontWeight: 500 }}>
                        Invoice:
                      </Typography>
                    </Box>
                    <Grid container>
                      {organizationName && patientName && (
                        <>
                          <Grid item xs={10}>
                            <Typography sx={{ textTransform: 'capitalize' }}>
                              {' '}
                              Status: {props?.invoiceObject?.status}
                            </Typography>
                          </Grid>

                          <Grid item xs={10}>
                            <Typography>
                              {' '}
                              Date:{' '}
                              {!_.isUndefined(props?.invoiceObject?.date)
                                ? dayjs(props?.invoiceObject?.date).format(
                                    'MM/DD/YYYY'
                                    // selectedVersion == 'IN'
                                    //   ? 'DD/MM/YYYY'
                                    //   : 'MM/DD/YYYY'
                                  )
                                : ''}
                            </Typography>
                          </Grid>
                        </>
                      )}
                    </Grid>
                  </Box>
                )}
              </Box>
            </Grid>
            {editMode ? null : (
              <Grid item xs={2}>
                <Grid
                  item
                  xs={12}
                  style={{
                    background: '#387CA3',
                    color: 'white',
                    padding: '15px',
                    borderRadius: '20%',
                    textAlign: 'center',
                    marginRight: '1px',
                  }}
                >
                  {console.log(
                    'invoice object ',
                    _.isEmpty(props?.invoiceObject)
                  )}
                  {!_.isEmpty(props?.invoiceObject) ? (
                    <p>
                      Grand Total{' '}
                      {props?.invoiceObject?.totalPriceComponent !== 0
                        ? props?.invoiceObject?.totalPriceComponent?.toLocaleString(
                            'en-US',
                            {
                              style: 'currency',
                              currency:
                                // 'USD'
                                selectedVersion == 'IN' ? 'INR' : 'USD',
                            }
                          )
                        : // '$ 0.00'

                          `${selectedVersion == 'IN' ? '₹' : '$'} 0.00`}
                    </p>
                  ) : (
                    // <p>Grand Total $0.00</p>
                    <p>Grand Total {selectedVersion == 'IN' ? '₹' : '$'}0.00</p>
                  )}
                </Grid>
              </Grid>
            )}
          </Grid>

          {editMode ? null : (
            <Grid item xs={12} style={{ paddingTop: '15px' }}>
              <Grid item xs={12}>
                <p className="sub-heading1 text-primary">
                  Added charge item(s):
                </p>
              </Grid>
              <Box>
                <table
                  className={isDark ? 'enliv-table-darkMode' : 'enliv-table'}
                >
                  <thead>
                    <tr>
                      <th>&nbsp;</th>
                      <th>Description</th>
                      <th>Status</th>
                      <th>Quantity</th>
                      <th>Price</th>
                      <th>&nbsp;</th>
                    </tr>
                  </thead>
                  <tbody>
                    {console.log('redux charge item ', chargeItemState)}
                    {Array.isArray(chargeItems) && chargeItems.length ? (
                      chargeItems.map((item, index) => {
                        return (
                          <tr>
                            {<td></td>}
                            <td>{_.capitalize(item.note)}</td>
                            <td>{_.capitalize(item.status)}</td>
                            <td>{item.quantity}</td>
                            {/* <td>${item.price}</td> */}
                            <td>{`${selectedVersion == 'IN' ? '₹' : '$'}${
                              item.price
                            }`}</td>
                            {<td></td>}
                          </tr>
                        );
                      })
                    ) : (
                      <tr height="40">
                        <td colSpan={9} className="text-light">
                          Add a code
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </Box>
            </Grid>
          )}

          {editMode ? (
            <>
              <Grid container spacing={2} style={{ paddingTop: '20px' }}>
                <Grid item xs={6}>
                  <Typography
                    sx={{
                      fontSize: 14,
                      '@media print': {
                        color: '#000',
                      },
                    }}
                  >
                    Invoice Status <span style={{ color: red[500] }}>*</span>
                  </Typography>
                  <FormControl fullWidth size="small">
                    <Select
                      size="small"
                      name="status"
                      error={!!errorMessage}
                      value={invoiceInitialState?.status.replace(
                        /(\b\w)/g,
                        match => match.toUpperCase()
                      )}
                      sx={{
                        '.MuiOutlinedInput-notchedOutline': {
                          borderColor: 'textFieldColor',
                          borderWidth: 2,
                        },
                        '.MuiFormHelperText-root': {
                          fontSize: '14px',
                        },
                        '@media print': {
                          color: '#000',
                          background: '#fff',
                        },
                      }}
                    >
                      {invoiceStatus.map(v => (
                        <MenuItem
                          value={v.display}
                          onClick={e => {
                            var valueRead = e.target.dataset.value;
                            var seleOption = e.target.innerText;
                            setInvoiceinitialState({
                              ...invoiceInitialState,
                              status: e.target.dataset.value,
                            });
                          }}
                        >
                          {v.display}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  {errorMessage && (
                    <span
                      style={{
                        color: '#F44336',
                        fontWeight: 'normal',
                        fontSize: '14px',
                      }}
                    >
                      {errorMessage}
                    </span>
                  )}
                </Grid>
                <Grid item xs={6}>
                  <DateSelectorWithTopLabelComponent
                    {...dateValidationObject}
                    onChange={handleOnChange}
                  />
                </Grid>
              </Grid>
              <Grid item xs={12} style={{ paddingTop: '20px' }}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <p className="sub-heading1 text-primary">
                    Add charge item(s) :
                  </p>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      marginLeft: '8px',
                    }}
                  >
                    <button
                      className="primary-btn smaller"
                      onClick={() => {
                        dispatch({ type: ACTION_RIGHT_DRAWER_NOT });
                        setInvoiceDialog({
                          open: true,
                          isEditMode: false,
                          data: {},
                        });
                      }}
                    >
                      Add
                    </button>
                  </Box>
                </Box>
                <Grid item xs={12}>
                  <Box>
                    <table
                      className={
                        isDark ? 'enliv-table-darkMode' : 'enliv-table'
                      }
                    >
                      <thead>
                        <tr>
                          <th>&nbsp;</th>
                          <th>Description</th>
                          <th>Status</th>
                          <th>Quantity</th>
                          <th>Price</th>
                          <th>&nbsp;</th>
                        </tr>
                      </thead>
                      <tbody>
                        {console.log(
                          'charge item state ',
                          chargeItemState?.chargeItem
                        )}
                        {Array.isArray(chargeItemState?.chargeItem) &&
                        chargeItemState?.chargeItem.length ? (
                          chargeItemState?.chargeItem.map((diagnosis, idx) => {
                            return (
                              <tr>
                                <td></td>
                                <td>{_.capitalize(diagnosis.note)}</td>
                                <td>{_.capitalize(diagnosis.status)}</td>
                                <td>{diagnosis.quantity}</td>
                                {/* <td>ssss${diagnosis.price}</td> */}
                                <td>{`${selectedVersion == 'IN' ? '₹' : '$'}${
                                  diagnosis.price
                                }`}</td>
                                <td>
                                  <IconButton component="span">
                                    <MoreVertIcon
                                      fontSize="small"
                                      onClick={event =>
                                        openMenuChargeItem(idx, event)
                                      }
                                    />
                                  </IconButton>
                                  <Menu
                                    id="long-menu"
                                    MenuListProps={{
                                      'aria-labelledby': 'long-button',
                                    }}
                                    anchorEl={menuOpen && menuOpen[idx]}
                                    open={Boolean(menuOpen && menuOpen[idx])}
                                    onClose={closeMenu}
                                    PaperProps={{
                                      style: {
                                        maxHeight: 15 * 4.5,
                                        width: '20ch',
                                      },
                                    }}
                                  >
                                    <MenuItem
                                      key={'edit'}
                                      onClick={() => editChargeItem(idx)}
                                    >
                                      Edit
                                    </MenuItem>
                                  </Menu>
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr height="40">
                            <td colSpan={6} className="text-light">
                              Add a charge item
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </Box>
                </Grid>
                <Grid
                  item
                  xs={12}
                  container
                  spacing={2}
                  style={{ paddingTop: '20px' }}
                >
                  <Grid item xs={9}></Grid>
                  {chargeItemState?.chargeItem?.length !== 0 &&
                    chargeItemState?.chargeItem?.map(item => {
                      if (isNaN(parseFloat(item?.price))) {
                        total = total;
                      } else {
                        total = total + Number(item.price);
                      }
                      {
                        console.log('total ', total);
                      }
                    })}
                  <Grid item xs={1}>
                    <Typography>Total: </Typography>
                  </Grid>
                  <Grid item xs={2}>
                    {console.log('total ', total)}
                    <Typography>
                      {/* {props?.invoiceObject?.totalPriceComponent !== 0
                    ? props?.invoiceObject?.totalPriceComponent.toLocaleString('en-US', {
                        style: 'currency',
                        currency: 'USD',
                      })
                    : '$ 0.00'} */}
                      {total !== 0
                        ? total.toLocaleString('en-US', {
                            style: 'currency',
                            // currency: 'USD',
                            currency: selectedVersion == 'IN' ? 'INR' : 'USD',
                          })
                        : // '$ 0.00'
                          `${selectedVersion == 'IN' ? '₹' : '$'} 0.00`}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </>
          ) : null}
        </Grid>
      ) : (
        <Grid
          item
          xs={12}
          className="overflow-grid"
          style={{ padding: '0px 15px' }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography
                style={{
                  color: '#387CA3',
                  paddingBottom: '5px',
                  fontWeight: 'bold',
                  fontSize: '20px',
                }}
              >
                Patient Invoice
              </Typography>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Divider
              style={{
                border: '1px solid #387CA3',
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <PatientSearchPage
              fromInvoice
              setSelectedPatient={setSelectedPatient}
              selectedPatientNew={selectedPatientNew}
              setSelectedPatientNew={setSelectedPatientNew}
            />
          </Grid>
          <Grid container spacing={2} style={{ padding: '20px' }}>
            <Grid item xs={6}>
              <Typography sx={{ fontSize: 14 }}>
                Invoice Status <span style={{ color: red[500] }}>*</span>
              </Typography>
              <FormControl fullWidth size="small">
                <Select
                  size="small"
                  name="status"
                  error={!!errorMessage}
                  value={invoiceInitialState?.status}
                  sx={{
                    '.MuiOutlinedInput-notchedOutline': {
                      borderColor: 'textFieldColor',
                      borderWidth: 2,
                    },
                    '.MuiFormHelperText-root': {
                      fontSize: '14px',
                    },
                  }}
                >
                  {invoiceStatus.map(v => (
                    <MenuItem
                      value={v.display}
                      onClick={e => {
                        var valueRead = e.target.dataset.value;
                        var seleOption = e.target.innerText;
                        setInvoiceinitialState({
                          ...invoiceInitialState,
                          status: e.target.dataset.value,
                        });
                      }}
                    >
                      {v.display}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              {errorMessage && (
                <span
                  style={{
                    color: '#F44336',
                    fontWeight: 'normal',
                    fontSize: '14px',
                  }}
                >
                  {errorMessage}
                </span>
              )}
            </Grid>
            <Grid item xs={6}>
              <DateSelectorWithTopLabelComponent
                {...dateValidationObject}
                onChange={handleOnChange}
              />
            </Grid>
          </Grid>
          <Grid item xs={12} style={{ paddingLeft: '20px' }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <p className="sub-heading1 text-primary">Add charge item(s) :</p>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  marginLeft: '8px',
                }}
              >
                <button
                  className="primary-btn smaller"
                  onClick={() => {
                    dispatch({ type: ACTION_RIGHT_DRAWER_NOT });
                    setInvoiceDialog({
                      open: true,
                      isEditMode: false,
                      data: {},
                    });
                  }}
                >
                  Add
                </button>
              </Box>
            </Box>
            <Grid item xs={12}>
              <Box>
                <table
                  className={isDark ? 'enliv-table-darkMode' : 'enliv-table'}
                >
                  <thead>
                    <tr>
                      <th>&nbsp;</th>
                      <th>Description</th>
                      <th>Status</th>
                      <th>Quantity</th>
                      <th>Price</th>
                      <th>&nbsp;</th>
                    </tr>
                  </thead>
                  <tbody>
                    {console.log(
                      'charge item state ',
                      chargeItemState?.chargeItem
                    )}
                    {Array.isArray(chargeItemState?.chargeItem) &&
                    chargeItemState?.chargeItem.length ? (
                      chargeItemState?.chargeItem.map((diagnosis, idx) => {
                        return (
                          <tr>
                            <td></td>
                            <td>{_.capitalize(diagnosis.note)}</td>
                            <td>{_.capitalize(diagnosis.status)}</td>
                            <td>{diagnosis.quantity}</td>
                            <td>${diagnosis.price}</td>
                            <td>
                              <IconButton component="span">
                                <MoreVertIcon
                                  fontSize="small"
                                  onClick={event =>
                                    openMenuChargeItem(idx, event)
                                  }
                                />
                              </IconButton>
                              <Menu
                                id="long-menu"
                                MenuListProps={{
                                  'aria-labelledby': 'long-button',
                                }}
                                anchorEl={menuOpen && menuOpen[idx]}
                                open={Boolean(menuOpen && menuOpen[idx])}
                                onClose={closeMenu}
                                PaperProps={{
                                  style: {
                                    maxHeight: 15 * 4.5,
                                    width: '20ch',
                                  },
                                }}
                              >
                                <MenuItem
                                  key={'edit'}
                                  onClick={() => editChargeItem(idx)}
                                >
                                  Edit
                                </MenuItem>
                              </Menu>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr height="40">
                        <td colSpan={6} className="text-light">
                          Add a charge item
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </Box>
            </Grid>
            <Grid
              item
              xs={12}
              container
              spacing={2}
              style={{ paddingTop: '20px' }}
            >
              <Grid item xs={9}></Grid>
              {chargeItemState?.chargeItem?.length !== 0 &&
                chargeItemState?.chargeItem?.map(item => {
                  if (isNaN(parseFloat(item?.price))) {
                    total = total;
                  } else {
                    total = total + Number(item.price);
                  }
                  {
                    console.log('total ', total);
                  }
                })}
              <Grid item xs={1}>
                <Typography>Total: </Typography>
              </Grid>
              <Grid item xs={2}>
                {console.log('total ', total)}
                <Typography>
                  {total !== 0
                    ? total.toLocaleString('en-US', {
                        style: 'currency',
                        currency: 'USD',
                      })
                    : '$ 0.00'}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      )}
    </>
  );
});

export default InvoiceNewPage;
